export const hasLowerAndUpperCase = (value: string) => {
  return /[a-z]/.test(value) && /[A-Z]/.test(value);
};
